/**
 * Calculates the progress percentage based on status and steps.
 *
 * @param {string} status - The current status (PENDING, STARTED, SUCCESS, FAILURE, etc.)
 * @param {number} currentStep - The current step number (default: 0)
 * @param {number} totalSteps - The total number of steps (default: 0)
 * @returns {number} The calculated progress percentage (0-100)
 */
export const calculateProgress = (status, currentStep = 0, totalSteps = 0) => {
  if (!status || status === 'IDLE') return 0;

  const statusUpper = status.toUpperCase();

  // Final states are always 100%
  if (
    ['SUCCESS', 'FAILURE', 'UNPROCESSABLE', 'NOT_FOUND'].includes(statusUpper)
  ) {
    return 100;
  }

  if (statusUpper === 'PENDING') return 0;

  if (statusUpper === 'STARTED') {
    if (!totalSteps || totalSteps <= 0) return 0;

    // Map steps to 0-100% range
    // Formula: (currentStep / totalSteps) * 100
    const percentage = (currentStep / totalSteps) * 100;

    // Clamp between 0 and 100
    return Math.min(100, Math.max(0, percentage));
  }

  return 0;
};
